export function statusBadgeProps(state: string, isOnline: boolean): { variant: "neutral" | "success" | "error" | "warning" | "info" | "primary"; outline?: boolean } {
  if (!isOnline) return { variant: "neutral" };
  const s = (state || "").toLowerCase();
  if (s === "charging" || s === "charging_simple") return { variant: "success" };
  if (s === "error") return { variant: "error" };
  if (s === "ready") return { variant: "warning", outline: true };
  if (s === "connected") return { variant: "info", outline: true };
  if (s === "standby") return { variant: "primary", outline: true };
  if (s.startsWith("unsupported")) return { variant: "warning" };
  if (s === "blocked") return { variant: "neutral" };
  return { variant: "neutral", outline: true };
}

export function kwhFromSessionEnergy(sessionEnergy: number): string {
  return (sessionEnergy / 1000).toFixed(2);
}

export function formatNum(n: number | undefined | null, digits = 0): string {
  const v = typeof n === "number" && isFinite(n) ? n : 0;
  return v.toFixed(digits);
}
